var _style, _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourSquaresIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.four-squares-icon-white-st0{clip-path:url(#SVGID_00000082340421806165912450000001068220110769299078_);}\n\t.four-squares-icon-white-st1{fill:#015BD7;enable-background:new    ;}\n\t.four-squares-icon-white-st2{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072999190213532518490000008885545430002221227_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000072999190213532518490000008885545430002221227_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "four-squares-icon-white-st2",
    d: "M19.1,4.1H4.9c-0.4,0-0.8,0.3-0.8,0.8v14.2c0,0.4,0.3,0.8,0.8,0.8h14.2c0.4,0,0.8-0.3,0.8-0.8V4.9 C19.9,4.5,19.5,4.1,19.1,4.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "four-squares-icon-white-st2",
    d: "M12,4.1v15.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "four-squares-icon-white-st2",
    d: "M19.9,12H4.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourSquaresIconWhite);
export default __webpack_public_path__ + "static/media/four_squares-icon_white.57679f467a48894df74803396dd81226.svg";
export { ForwardRef as ReactComponent };